/* eslint-disable */
export default {
  _click: 'click',
  _lg_snow: 'lg_snow',
  _sm_snow: 'sm_snow',
  _throw_1: 'throw_1',
  _throw_2: 'throw_2',
}